import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";

export const ViewProjectWrapper = styled.div`
  padding-top: 6px;
  color: ${COLORS.cirrus_black};

  .bottom-button-container {
    height: 104px;
    display: flex;
    justify-content: end;
    align-items: center;
    padding: 0px 16px;
    background-color: ${COLORS.cirrus_white};
    margin-bottom: 20px;
    ${responsive.MOBILE`
        width: 100%;
        padding: 16px 8px 16px 8px;
        gap: 12px;
        height: auto;
        flex-direction: column-reverse;
        margin-bottom: 16px;
      `}

    .bottom-button-edit, .bottom-button-close {
      ${responsive.MOBILE`
          width: 100%;
          margin: 0;
        `}
    }

    .bottom-button-edit {
      margin-left: 12px;
      ${responsive.MOBILE`
          margin-left: 0;
        `}
    }
  }
`;
